import styled from 'styled-components';
import { TextError } from '../../../../../core/components/questions-components/styles';

export const InlineErrorMessage = styled(TextError)`
  &&& {
    margin-top: 0px;
    margin-left: 15px;
  }
`;
